// extracted by mini-css-extract-plugin
export var locationCard = "_r9-0";